export default __webpack_public_path__ + "static/media/assist_web-lg@2x.ac25276a.jpg";